import Rx from "rxjs/Rx";
import $ from "jquery";

export const serviceIconClickedEventSource = new Rx.Subject();
export const serviceIconClicked$ = serviceIconClickedEventSource.asObservable();

/*
 * Finds and initializes one specific service-icons component.
 * Fires serviceIconClicked$ event, global for all service-icons components.
 * Sets active or passive state dependent on serviceIconClicked$ index argument.
 */

/* eslint no-use-before-define: 0 */

export class ServiceIconComponent {
    constructor(jqDomObject, GUID, index, parentJqDomObject) {
        this.GUID = GUID;
        this.jqDomObject = jqDomObject;
        this.childIndex = index;
        this.descriptionText = $(`#service-list-template-${this.GUID}-${this.childIndex}`).html();
        this.parentJqDomObject = parentJqDomObject;

        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        const scope = this;

        subscribeOnEvents();

        function subscribeOnEvents() {
            scope.jqDomObject.on("click",
                () => {
                    serviceIconClickedEventSource.next(scope.childIndex);
                });

            serviceIconClicked$.subscribe((index) => {
                if (index === scope.childIndex) {
                    scope.setActiveState();
                } else {
                    scope.setPassiveState();
                }
            });
        }
    }

    /**
     * @private
     */
    setActiveState() {
        const scope = this;

        /*
         * setActiveState will be called only for once service icon in whole serviceList component.
         * So it is safe to call it here.
         */
        this.clearAllDescriptionSlots();

        this.jqDomObject.addClass("active");

        const descriptionBlock = findDescriptionBlock();
        descriptionBlock.html(this.descriptionText);

        /**
         * @returns {Object} - jqNode
         */
        function findDescriptionBlock() {
            return scope.jqDomObject.nextAll(".service-list-item-description").filter(function hasDisplayBlock() {
                return $(this).css("display") === "block";
            }).eq(0);
        }
    }

    /**
     * @private
     */
    clearAllDescriptionSlots() {
        this.parentJqDomObject.find(".service-list-item-description").html("");
    }

    /**
     * @private
     */
    setPassiveState() {
        this.jqDomObject.removeClass("active");
    }
}
